<template>
  <div>
    <div>
      <v-layout row>
        <v-flex xs9>
          <h3 :style="titleStyle">Instruction to Driver</h3>
        </v-flex>
        <v-flex
          xs3
          text-xs-right
        >
          <div class="mr-3" style="margin-top: -9px;" v-if="editable">
            <v-btn
              icon
              small
              @click="openDialog"
            >
              <span class="mr-1" :style="changeStyle">{{ $t('change') }}</span>
              <v-icon
                small
                :color="theme.trashcan_color"
              >fas fa-edit</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="remarks">
      <span :style="addressStyle" class="font-italic">{{ remarks }}</span>
    </div>
    <div v-if="address.cutlery && !editable">
      <span class="pa-0 ma-0" slot="label" :style="cutleryLabelStyle" >{{ cutleryLabel }}</span>
    </div>
    <v-dialog
      v-model="dialog"
      persistent
    >
      <v-card :color="theme.login_bg_color">
        <v-card-text class="pa-4">
          <v-layout row>
            <v-flex
              xs12
              sm10
              offset-sm1
              md8
              offset-md2
              lg6
              offset-lg3
              xl6
              offset-xl3
            >
              <v-layout
                row
                align-center
              >
                <v-flex xs6>
                  <span class="main-title">{{ $t('remarks') }}</span>
                </v-flex>
              </v-layout>
              <div>
                <div class="mt-3 mb-0">
                  <v-text-field
                    v-model="remarksInput"
                    outline
                    :style="inputAddressStyle"
                    clearable
                    ref="remarksField"
                    name="remarks"
                    label="Remarks (optional)"
                    placeholder="any special remarks"
                    hide-details
                    autocomplete="off"
                  ></v-text-field>
                </div>
                <div class="text-xs-center">
                  <v-btn
                    :dark="enableBtn"
                    :color="theme.btn_color_secondary"
                    @click="saveRemarks"
                    :disabled="!enableBtn"
                  >
                    {{ $t('save') }}
                  </v-btn>
                  <v-btn
                    flat
                    :color="theme.btn_color_secondary"
                    @click="closeRemarks"
                  >
                    {{ $t('close') }}
                  </v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-divider class="mt-2 mb-2" :color="theme.orders_divider_color" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      dialog: false,
      enableBtn: true,
      remarksInput: null,
    }
  },
  props: {
    editable: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    ...mapGetters('auth', [
      'user', 'addresses'
    ]),
    ...mapGetters('config', [
      'theme', 'language'
    ]),
    ...mapGetters('delivery', [
      'address', 'isDeliverable', 'deliveryInfo', 'addressString'
    ]),
    ...mapGetters('cart', ['remarks']),
    cutleryLabel () {
      if (this.language === 'zh-SG') {
        return this.cutlery || this.address.cutlery ? "我需要餐具。" : "我不需要餐具。"
      }
      return this.cutlery || this.address.cutlery ? "I need cutlery." : "I do not need cutlery."
    },
    cutleryLabelStyle () {
      return {
        color: this.theme.cart_name_color
      }
    },
    changeStyle () {
      return {
        color: this.theme.trashcan_color
      }
    },
    titleStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    addressStyle () {
      return {
        color: this.theme.cart_name2_color
      }
    },
    inputAddressStyle () {
      return {
        marginTop: '10px',
        color: this.theme.cart_name_color,
      }
    },
    myAddressTitleStyle () {
      return {
        fontSize: '12px',
        color: this.theme.btn_color_secondary
      }
    },
    addressNotEmpty () {
      let addressNotEmpty = false
      Object.keys(this.inputAddress).forEach(key => {
        if (key != 'country' && this.inputAddress[key] && this.inputAddress[key] !== '') {
          addressNotEmpty = true
        }
      })
      return addressNotEmpty
    },
    addressMsg () {
      return !this.isDeliverable ? (this.deliveryInfo.msg ? this.deliveryInfo.msg : this.$t('postal_code_not_ready')) : ''
    },
    hasUserAddress () {
      return this.user && this.addresses && this.addresses.length > 0
    },
    listStyle () {
      return {
        listStyleType: 'none',
        paddingLeft: '0',
        color: this.theme.cart_name2_color
      }
    }
  },
  methods: {
    async openDialog () {
      this.dialog = true
    },
    async checkAddress () {
      if (this.inputAddress.postal_code.length === 6) {
        await this.$store.dispatch('delivery/fetchDeliveryInfo', this.inputAddress.postal_code)
      } else {
        this.$store.dispatch('delivery/resetDeliveryInfo')
      }
      if (!this.isDeliverable) {
        this.enableBtn = false
      } else {
        this.enableBtn = true
        const location = this.deliveryInfo.location
        this.inputAddress.block_no = location.block_no ? location.block_no : ''
        this.inputAddress.road_name = location.road_name ? location.road_name : ''
        this.inputAddress.building = location.building ? location.building : ''
      }
    },
    saveRemarks () {
      this.dialog = false
      this.$store.dispatch('cart/setRemarks', this.remarksInput)
      this.$store.dispatch('delivery/setAddressRemarks', this.remarksInput)
    },
    removeRemarks () {
      this.$store.dispatch('cart/resetRemarks')
    },
    closeRemarks () {
      this.dialog = false
    },
    async changeTab () {
      this.otherAddress = !this.otherAddress
      // Refetch after select
      if (!this.otherAddress) {
        await this.$store.dispatch('delivery/fetchDeliveryInfo', this.inputAddress.postal_code)
      }
    },
    selectAddress (address) {
      if (this.isDeliverable) {
        this.dialog = false
        this.otherAddress = false
        this.inputAddress = address
        this.$store.dispatch('delivery/setAddress', address)
      }
    }
  },
  beforeMount () {
    this.cutlery = this.address.cutlery ? this.address.cutlery : false
  }
}
</script>

<style scoped>
.main-title {
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/components/DeliveryRemarks.vue